class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.initGrid();
      this.initObserver();
      this.currentPage = 1;
      this.productGridContainer = document.querySelector('.product-grid-facets-container');
      this.scrollToTopBtn = document.querySelector('.scroll-to-top-button');
      this.loaderContainer = document.querySelector('.infinite-loading-box');
      this.reachedEndText = document.querySelector('.end-of-grid');

      this.headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height').match(/\d+/)[0]);
      this.productGridContainerTop = this.productGridContainer.getBoundingClientRect().top;

      this.scrollToTopBtn.addEventListener('click', this.scrollToTop.bind(this));
      
      window.addEventListener('scroll', this.toggleScrollToTopButton.bind(this));
    }

    initGrid() {
        let gridName = "product-grid";
        let grid = document.getElementById(gridName);
        if (grid) {
            this.gridName = gridName;
            this.gridContainer = grid;
        }
    }

    initObserver() {
      const observer = new IntersectionObserver(this.revealItem.bind(this), {
        root: null,
        threshold: 0.05,
      });
      observer.observe(this);
    }

    fetchNextPage(pageNumber) {
      if (pageNumber <= this.dataset.pageSize) {
        const nextPageUrl = `${this.dataset.shopUrl}/${this.dataset.next}`;
        const url = new URL(nextPageUrl);
        url.searchParams.set('page', pageNumber);
        const finalUrl = url.href;
        
        fetch(finalUrl, { method: 'GET', headers: { 'Content-Type': 'text/html' } })
          .then((response) => response.text())
          .then((htmlContent) => {
            const parsedDocument = new DOMParser().parseFromString(htmlContent, 'text/html');
            const nextProductsHtml = parsedDocument.getElementById(this.gridName).innerHTML;
            
            // FIX-61423 Extraction de l'URL exacte next page depuis le HTML reçu
            const nextPageElement = parsedDocument.querySelector('infinite-scroll');
            if (nextPageElement) {
              this.dataset.next = nextPageElement.dataset.next;
            }
            
            this.gridContainer.insertAdjacentHTML('beforeend', nextProductsHtml);

            if (pageNumber == this.dataset.pageSize) {
                this.loaderContainer.style.display = "none";
                this.reachedEndText.style.display = "flex";
            }
          })
          .then(() => updateSwiperJsAfterProductsGridChanged())
          .catch((error) => {
            console.error('Error:', error);
          });
      }
    }

    revealItem(entries, observer) {
      const [entry] = entries;

      if (!entry.isIntersecting) return;

      if (entry.target) {
        this.currentPage++;
        this.fetchNextPage(this.currentPage);
      }

      if (this.currentPage == this.dataset.pageSize) {
        observer.unobserve(entry.target);
      }
    }

  getAbsoluteTopPosition(element) {
      const rect = element.getBoundingClientRect();
      return rect.top + window.scrollY
  }
    
    scrollToTop() {
        const targetPositionTop = this.getAbsoluteTopPosition(this.productGridContainer) - this.headerHeight; 
        window.scrollTo({ top: targetPositionTop, behavior: 'smooth'});
    }

    toggleScrollToTopButton() {
        if (window.scrollY > this.productGridContainerTop)  {
            this.scrollToTopBtn.classList.add('show');
        } else {
            this.scrollToTopBtn.classList.remove('show');
        }
    }
}

customElements.define('infinite-scroll', InfiniteScroll);